// import React, { useEffect, useState, useMemo, useCallback } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Box,
//   Pagination,
//   Button,
//   Typography,
// } from "@mui/material";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   deleteDonation,
//   fetchConsolidatedDonations,
// } from "../../redux/donationSlice";
// import { filterDonations, exportDonationsToExcel } from "./utils/DonationUtils";
// import {
//   reorderColumnsUtil,
//   toggleColumnVisibilityUtil,
//   resetToDefaultUtil,
// } from "./utils/columnPreferenceUtils";
// import { consolidateDataHandler } from "./utils/consolidateDataHandler";
// import RowWithPreferences from "./RowWithPreferences";
// import Filter from "../Filter";
// import ConfirmationDialog from "../ConfirmationDialog";
// import HistoryModal from "../HistoryModal";
// import SnackbarAlert from "../SnackBarAlert";
// import AgGridLoader from "../AgGridLoader";
// import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
// import { logger } from "../../utils/logger";
// import { fetchPayPurpose } from "../../redux/paypurposeSlice";
// import AlertMessage from "../AlertMessage";
// import { DEFAULT_DONATION_COLUMNS, DEFAULT_DONOR_LIST_COLUMNS } from "../../config/donationTableColumns";
// import { loadTablePreferences } from "../../redux/tablePreferenceSlice";
// import {
//   DndContext,
//   PointerSensor,
//   useSensor,
//   useSensors,
// } from "@dnd-kit/core";
// import {
//   SortableContext,
//   horizontalListSortingStrategy,
// } from "@dnd-kit/sortable";
// import SortableColumnHeader from "./SortableColumnHeader";

// const DonationList = ({ onEdit, onAppend, filterData }) => {
//   const dispatch = useDispatch();

//   const tableId = "donationTable";
//   const parentTableId = "donorListTable";
//   const tableState = useSelector(
//     (state) => state.tablePreference?.tables?.[tableId]
//   );
//   const parentTableState = useSelector(
//     (state) => state.tablePreference?.tables?.[parentTableId]
//   );

//   const columns = tableState?.columns || DEFAULT_DONATION_COLUMNS;
//   const parentColumns = parentTableState?.columns || DEFAULT_DONOR_LIST_COLUMNS;

//   // Load from backend when page loads
//   useEffect(() => {
//     dispatch(
//       loadTablePreferences({
//         tableId,
//         defaultColumns: DEFAULT_DONATION_COLUMNS,
//       })
//     );
//     dispatch(
//       loadTablePreferences({
//         tableId: parentTableId,
//         defaultColumns: DEFAULT_DONOR_LIST_COLUMNS,
//       })
//     );
//   }, []);

//   const sensors = useSensors(
//     useSensor(PointerSensor, {
//       activationConstraint: { distance: 5 },
//     })
//   );

//   const reorderColumns = (startIndex, endIndex) => {
//     reorderColumnsUtil(columns, startIndex, endIndex, dispatch, tableId);
//   };

//   const reorderParentColumns = (startIndex, endIndex) => {
//     reorderColumnsUtil(parentColumns, startIndex, endIndex, dispatch, parentTableId);
//   };

//   const toggleColumnVisibility = useCallback(
//     (columnId) => {
//       toggleColumnVisibilityUtil(columnId, columns, dispatch, tableId);
//     },
//     [columns, dispatch, tableId]
//   );

//   const toggleParentColumnVisibility = useCallback(
//     (columnId) => {
//       toggleColumnVisibilityUtil(columnId, parentColumns, dispatch, parentTableId);
//     },
//     [parentColumns, dispatch, parentTableId]
//   );

//   const resetToDefault = useCallback(() => {
//     resetToDefaultUtil(DEFAULT_DONATION_COLUMNS, dispatch, tableId);
//   }, [dispatch, tableId]);

//   const resetParentToDefault = useCallback(() => {
//     resetToDefaultUtil(DEFAULT_DONOR_LIST_COLUMNS, dispatch, parentTableId);
//   }, [dispatch, parentTableId]);

//   const { consolidatedDonations = [] } = useSelector(
//     (state) => state.donation || {}
//   );
//   const { donations = [], loading } = useSelector(
//     (state) => state.donation || {}
//   );
//   const payPurposes = useSelector(
//     (state) => state.paypurpose?.paypurpose || []
//   );
//   const [searchFilters, setSearchFilters] = useState({
//     donorId: "",
//     bookNo: "",
//     remarks: "",
//     globalSearch: "",
//   });
//   const [page, setPage] = useState(1);
//   const [feedback, setFeedback] = useState({
//     open: false,
//     message: "",
//     severity: "info",
//   });
//   const [openConfirm, setOpenConfirm] = useState(false);
//   const [selectedDonation, setSelectedDonation] = useState(null);
//   const [historyOpen, setHistoryOpen] = useState(false);
//   const [selectedHistory, setSelectedHistory] = useState([]);
//   const { role } = useSelector((state) => state.auth || "user");
//   const { user } = useSelector((state) => state.auth);
//   const [alertOpen, setAlertOpen] = useState(false);
//   const [alertMessage, setAlertMessage] = useState("");

//   const donorsPerPage = 10;

//   // Fetch data only if store is empty
//   useEffect(() => {
//     if (!consolidatedDonations || consolidatedDonations.length === 0) {
//       // Show loading immediately
//       setFeedback({
//         open: true,
//         message: "Loading donations... This may take a moment.",
//         severity: "info",
//       });

//       dispatch(fetchConsolidatedDonations())
//         .unwrap()
//         .then((consolidatedData) => {
//           logger.info("Consolidated donations fetched successfully", {
//             count: consolidatedData.length,
//             username: user?.username,
//             role: user?.role,
//           });
//         })
//         .catch((err) => {
//           logger.error("Error fetching consolidated donations", {
//             error: err,
//             username: user?.username,
//             role: user?.role,
//           });
//           setFeedback({
//             open: true,
//             message: "Error fetching donations",
//             severity: "error",
//           });
//         });
//     }
//   }, [dispatch, consolidatedDonations, user]);

//   useEffect(() => {
//     if (filterData?.transactionId) {
//       setSearchFilters((prev) => ({
//         ...prev,
//         globalSearch: "",
//         donorId: "",
//         bookNo: "",
//         remarks: "",
//         receiptNo: "",
//         transactionId: filterData.transactionId,
//       }));
//     }
//   }, [filterData]);

//   // Fetch PayPurpose only if store is empty
//   useEffect(() => {
//     if (!payPurposes || payPurposes.length === 0) {
//       dispatch(fetchPayPurpose());
//     }
//   }, [dispatch, payPurposes]);

//   const handleDeleteDonation = (donation) => {
//     // Check if this is a parent receipt with child receipts
//     const parentReceipt = consolidatedDonations.find(
//       (c) => c.parentDetails?._id === donation._id
//     );

//     if (
//       parentReceipt &&
//       parentReceipt.childReceipts &&
//       parentReceipt.childReceipts.length > 0
//     ) {
//       setAlertMessage(
//         "This parent receipt cannot be deleted because it has child receipts. Please delete the child receipts first."
//       );
//       setAlertOpen(true);
//       return;
//     }

//     const hasPayPurpose = payPurposes.some(
//       (p) =>
//         p.donorId === donation.donorId &&
//         p.transactionId === donation.transactionId
//     );

//     if (hasPayPurpose) {
//       setAlertMessage(
//         "This donation cannot be deleted because it has associated PayPurpose details."
//       );
//       setAlertOpen(true);
//       return;
//     }

//     setSelectedDonation(donation);
//     setOpenConfirm(true);
//   };

//   const { filteredConsolidatedDonations, groupedByDonor, totalIndividualDonations } =
//     useMemo(() => {
//       return consolidateDataHandler(consolidatedDonations, searchFilters);
//     }, [consolidatedDonations, searchFilters]);

//   const paginatedDonors = useMemo(() => {
//     const start = (page - 1) * donorsPerPage;
//     return groupedByDonor.slice(start, start + donorsPerPage);
//   }, [groupedByDonor, page]);

//   const handleFilterChange = (filters) => {
//     setSearchFilters(filters);
//     setPage(1);
//     logger.info("Donation table search applied", {
//       filtersApplied: filters,
//       username: user?.username,
//       role: user?.role,
//     });
//   };

//   const handleAddDonation = (data) => {
//     const donorDetails = {
//       donorId: data.donorId,
//       firstName: data.firstName,
//       lastName: data.lastName,
//       mobile1: data.mobile1,
//       city: data.city,
//     };
//     logger.info("Add donation clicked", {
//       donorId: data.donorId,
//       username: user?.username,
//       role: user?.role,
//     });
//     onAppend(donorDetails);
//   };

//   const handleEdit = (data) => {
//     logger.info("Edit donation clicked", {
//       donorId: data.donorId,
//       transactionId: data.transactionId,
//       username: user?.username,
//       role: user?.role,
//     });
//     onEdit(data);
//   };

//   const handleDeleteConfirm = () => {
//     if (selectedDonation) {
//       dispatch(deleteDonation(selectedDonation._id))
//         .unwrap()
//         .then(() => {
//           setFeedback({
//             open: true,
//             message: "Donation deleted successfully",
//             severity: "success",
//           });
//           logger.info("Donation deleted", {
//             donorId: selectedDonation.donorId,
//             transactionId: selectedDonation.transactionId,
//             username: user?.username,
//             role: user?.role,
//           });
//         })
//         .catch((err) => {
//           setFeedback({
//             open: true,
//             message: "Error deleting donation",
//             severity: "error",
//           });
//           logger.error("Error deleting donation", {
//             error: err,
//             donorId: selectedDonation.donorId,
//             transactionId: selectedDonation.transactionId,
//             username: user?.username,
//             role: user?.role,
//           });
//         });
//     }
//     setOpenConfirm(false);
//     setSelectedDonation(null);
//   };

//   const handleViewHistory = (donation) => {
//     if (donation.updateHistory && donation.updateHistory.length > 0) {
//       setSelectedHistory(donation.updateHistory);
//       setHistoryOpen(true);
//       logger.info("View updated donation history modal open", {
//         donorId: donation.donorId,
//         transactionId: donation.transactionId,
//         username: user?.username,
//         role: user?.role,
//       });
//     } else {
//       setFeedback({
//         open: true,
//         message: "No history available for this donation",
//         severity: "info",
//       });
//       logger.info("No donation history available", {
//         donorId: donation.donorId,
//         transactionId: donation.transactionId,
//         username: user?.username,
//         role: user?.role,
//       });
//     }
//   };

//   const handleCloseHistory = () => {
//     setHistoryOpen(false);
//     setSelectedHistory([]);
//     logger.info("View updated donation history modal close", {
//       username: user?.username,
//       role: user?.role,
//     });
//   };

//   const handleCloseFeedback = () => {
//     setFeedback({ ...feedback, open: false });
//   };

//   return (
//     <>
//       <Filter
//         onFilterChange={handleFilterChange}
//         values={searchFilters}
//         fields={["donorId", "bookNo", "remarks", "receiptNo"]}
//       />
//       <Box display="flex" justifyContent="end">
//         {role === "superadmin" || role === "admin1" || role === "admin2" ? (
//           <Button
//             onClick={() => {
//               const allDonations = [];
//               if (Array.isArray(consolidatedDonations)) {
//                 consolidatedDonations.forEach((consolidated) => {
//                   if (consolidated?.parentDetails) {
//                     allDonations.push(consolidated.parentDetails);
//                   }
//                 });
//               }
//               exportDonationsToExcel(allDonations, user);
//             }}
//             variant="contained"
//             color="primary"
//           >
//             <DriveFileMoveIcon /> Export
//           </Button>
//         ) : null}
//       </Box>
//       <TableContainer
//         component={Paper}
//         sx={{
//           maxHeight: 782,
//           overflowY: "auto",
//           overflowX: "hidden",
//           width: "100%",
//         }}
//       >
//         <Table stickyHeader sx={{ width: "100%", tableLayout: "fixed" }}>
//           <TableHead>
//             <DndContext sensors={sensors} onDragEnd={(event) => {
//               const { active, over } = event;
//               if (!over || active.id === over.id) return;
//               const oldIndex = parentColumns.findIndex((c) => c.id === active.id);
//               const newIndex = parentColumns.findIndex((c) => c.id === over.id);
//               reorderParentColumns(oldIndex, newIndex);
//             }}>
//               <SortableContext
//                 items={parentColumns.filter((c) => c.visible !== false).map((c) => c.id)}
//                 strategy={horizontalListSortingStrategy}
//               >
//                 <TableRow>
//                   {parentColumns.filter((c) => c.visible !== false).map((col) => (
//                     <SortableColumnHeader key={col.id} column={col}>
//                       <TableCell sx={{ width: col.width }}>
//                         {col.label}
//                       </TableCell>
//                     </SortableColumnHeader>
//                   ))}
//                 </TableRow>
//               </SortableContext>
//             </DndContext>
//           </TableHead>
//           <TableBody>
//             {loading ? (
//               <TableRow>
//                 <TableCell colSpan={parentColumns.filter((c) => c.visible !== false).length}>
//                   <Box
//                     display="flex"
//                     justifyContent="center"
//                     alignItems="center"
//                     height="100%"
//                   >
//                     <AgGridLoader loadingMessage="Fetching Donations, please wait..." />
//                   </Box>
//                 </TableCell>
//               </TableRow>
//             ) : paginatedDonors.length === 0 ? (
//               <TableRow>
//                 <TableCell colSpan={parentColumns.filter((c) => c.visible !== false).length}>
//                   <Box
//                     display="flex"
//                     justifyContent="center"
//                     alignItems="center"
//                     height="100%"
//                   >
//                     <Typography variant="h6">No Donations Found</Typography>
//                   </Box>
//                 </TableCell>
//               </TableRow>
//             ) : (
//               paginatedDonors.map((donor) => {
//                 //Safety check
//                 if (!donor || !donor.donorDetails) {
//                   return null;
//                 }
//                 // Find consolidated total for this donor's base receiptNo
//                 const base = donor.receiptNo
//                   ? donor.receiptNo.split("-")[0]
//                   : "";
//                 const cons = consolidatedDonations.find((c) => c._id === base);
//                 const allDonations = [];
//                 donor.receipts.forEach((receipt) => {
//                   // Add parent receipt with totalAmount from the receipt object
//                   if (receipt.parentDetails) {
//                     allDonations.push({
//                       ...receipt.parentDetails,
//                       totalAmount: receipt.totalAmount || receipt.parentDetails.amount,
//                     });
//                   }
//                   // Add child receipts
//                   if (
//                     receipt.childReceipts &&
//                     Array.isArray(receipt.childReceipts)
//                   ) {
//                     allDonations.push(...receipt.childReceipts);
//                   }
//                 });
//                 const totalAmount = donor.receipts.reduce(
//                   (sum, r) => sum + (r.totalAmount || 0),
//                   0
//                 );

//                 // Visible parent columns
//                 const visibleParentColumns = parentColumns.filter((c) => c.visible !== false);

//                 return (
//                   <RowWithPreferences
//                     key={donor.donorId}
//                     donor={donor.donorDetails}
//                     allDonations={allDonations}
//                     payPurposes={payPurposes}
//                     donationCount={allDonations.length}
//                     totalAmount={totalAmount}
//                     onEdit={handleEdit}
//                     onDelete={handleDeleteDonation}
//                     onView={handleViewHistory}
//                     onAppend={handleAddDonation}
//                     role={role}
//                     amount={cons ? cons.totalAmount : donor.amount}
//                     columnPreferences={columns}
//                     parentColumnPreferences={visibleParentColumns}
//                     reorderColumns={reorderColumns}
//                     reorderParentColumns={reorderParentColumns}
//                     toggleColumnVisibility={toggleColumnVisibility}
//                     toggleParentColumnVisibility={toggleParentColumnVisibility}
//                     resetToDefault={resetToDefault}
//                     resetParentToDefault={resetParentToDefault}
//                   />
//                 );
//               })
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>
//       <Box
//         display="flex"
//         alignItems="center"
//         justifyContent="space-between"
//         mt={2}
//       >
//         <Typography variant="body2" color="textSecondary">
//           {`${(page - 1) * donorsPerPage + 1} to ${Math.min(
//             page * donorsPerPage,
//             groupedByDonor.length
//           )} of ${groupedByDonor.length} | Page ${page} of ${Math.ceil(
//             groupedByDonor.length / donorsPerPage
//           )}`}
//         </Typography>

//         <Pagination
//           count={Math.ceil(groupedByDonor.length / donorsPerPage)}
//           page={page}
//           onChange={(e, value) => setPage(value)}
//           color="primary"
//           shape="rounded"
//         />

//         <Typography variant="body2" color="textSecondary">
//           Total Donations: {totalIndividualDonations}
//         </Typography>
//       </Box>

//       <HistoryModal
//         title="Donation Updated History"
//         open={historyOpen}
//         onClose={handleCloseHistory}
//         history={selectedHistory}
//       />
//       <ConfirmationDialog
//         open={openConfirm}
//         title="Confirm Deletion"
//         message="Are you sure you want to delete this donation?"
//         onConfirm={handleDeleteConfirm}
//         onCancel={() => setOpenConfirm(false)}
//       />
//       <AlertMessage
//         title="Donation Delete Alert"
//         open={alertOpen}
//         setOpen={setAlertOpen}
//         message={alertMessage}
//       />

//       <SnackbarAlert feedback={feedback} onClose={handleCloseFeedback} />
//     </>
//   );
// };
// export default DonationList;
import React, { useEffect, useState, useMemo, useCallback } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Pagination,
  Button,
  Typography,
} from "@mui/material";
import Chip from "@mui/material/Chip"; // ✅ fixes branch: transaction filter chip
import { useDispatch, useSelector } from "react-redux";
import {
  deleteDonation,
  fetchConsolidatedDonations,
} from "../../redux/donationSlice";
import { filterDonations, exportDonationsToExcel } from "./utils/DonationUtils";
import {
  reorderColumnsUtil,
  toggleColumnVisibilityUtil,
  resetToDefaultUtil,
} from "./utils/columnPreferenceUtils";
import { consolidateDataHandler } from "./utils/consolidateDataHandler";
import RowWithPreferences from "./RowWithPreferences"; // ✅ phase3
import Filter from "../Filter";
import ConfirmationDialog from "../ConfirmationDialog";
import HistoryModal from "../HistoryModal";
import SnackbarAlert from "../SnackBarAlert";
import AgGridLoader from "../AgGridLoader";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import { logger } from "../../utils/logger";
import { fetchPayPurpose } from "../../redux/paypurposeSlice";
import AlertMessage from "../AlertMessage";
import {
  DEFAULT_DONATION_COLUMNS,
  DEFAULT_DONOR_LIST_COLUMNS,
} from "../../config/donationTableColumns"; // ✅ phase3
import { loadTablePreferences } from "../../redux/tablePreferenceSlice"; // ✅ phase3
import {
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core"; // ✅ phase3
import {
  SortableContext,
  horizontalListSortingStrategy,
} from "@dnd-kit/sortable"; // ✅ phase3
import SortableColumnHeader from "./SortableColumnHeader"; // ✅ phase3

const DonationList = ({ onEdit, onAppend, filterData }) => {
  const dispatch = useDispatch();

  // ✅ phase3: column preference table IDs
  const tableId = "donationTable";
  const parentTableId = "donorListTable";

  const tableState = useSelector(
    (state) => state.tablePreference?.tables?.[tableId]
  );
  const parentTableState = useSelector(
    (state) => state.tablePreference?.tables?.[parentTableId]
  );

  const columns = tableState?.columns || DEFAULT_DONATION_COLUMNS;
  const parentColumns =
    parentTableState?.columns || DEFAULT_DONOR_LIST_COLUMNS;

  // ✅ fixes branch: cleaner - loading destructured alongside consolidatedDonations
  const { consolidatedDonations = [], loading } = useSelector(
    (state) => state.donation || {}
  );

  const payPurposes = useSelector(
    (state) => state.paypurpose?.paypurpose || []
  );

  const [searchFilters, setSearchFilters] = useState({
    donorId: "",
    bookNo: "",
    remarks: "",
    globalSearch: "",
  });
  const [page, setPage] = useState(1);
  const [feedback, setFeedback] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedDonation, setSelectedDonation] = useState(null);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState([]);
  const { role } = useSelector((state) => state.auth || "user");
  const { user } = useSelector((state) => state.auth);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const donorsPerPage = 10;

  // ✅ phase3: Load column preferences from backend on mount
  useEffect(() => {
    dispatch(
      loadTablePreferences({
        tableId,
        defaultColumns: DEFAULT_DONATION_COLUMNS,
      })
    );
    dispatch(
      loadTablePreferences({
        tableId: parentTableId,
        defaultColumns: DEFAULT_DONOR_LIST_COLUMNS,
      })
    );
  }, []);

  // ✅ phase3: DnD sensors
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 5 },
    })
  );

  // ✅ phase3: column reorder/toggle/reset helpers
  const reorderColumns = (startIndex, endIndex) => {
    reorderColumnsUtil(columns, startIndex, endIndex, dispatch, tableId);
  };

  const reorderParentColumns = (startIndex, endIndex) => {
    reorderColumnsUtil(
      parentColumns,
      startIndex,
      endIndex,
      dispatch,
      parentTableId
    );
  };

  const toggleColumnVisibility = useCallback(
    (columnId) => {
      toggleColumnVisibilityUtil(columnId, columns, dispatch, tableId);
    },
    [columns, dispatch, tableId]
  );

  const toggleParentColumnVisibility = useCallback(
    (columnId) => {
      toggleColumnVisibilityUtil(
        columnId,
        parentColumns,
        dispatch,
        parentTableId
      );
    },
    [parentColumns, dispatch, parentTableId]
  );

  const resetToDefault = useCallback(() => {
    resetToDefaultUtil(DEFAULT_DONATION_COLUMNS, dispatch, tableId);
  }, [dispatch, tableId]);

  const resetParentToDefault = useCallback(() => {
    resetToDefaultUtil(DEFAULT_DONOR_LIST_COLUMNS, dispatch, parentTableId);
  }, [dispatch, parentTableId]);

  // Fetch consolidated donations only if store is empty
  useEffect(() => {
    if (!consolidatedDonations || consolidatedDonations.length === 0) {
      setFeedback({
        open: true,
        message: "Loading donations... This may take a moment.",
        severity: "info",
      });

      dispatch(fetchConsolidatedDonations())
        .unwrap()
        .then((consolidatedData) => {
          logger.info("Consolidated donations fetched successfully", {
            count: consolidatedData.length,
            username: user?.username,
            role: user?.role,
          });
        })
        .catch((err) => {
          logger.error("Error fetching consolidated donations", {
            error: err,
            username: user?.username,
            role: user?.role,
          });
          setFeedback({
            open: true,
            message: "Error fetching donations",
            severity: "error",
          });
        });
    }
  }, [dispatch, consolidatedDonations, user]);

  // ✅ fixes branch: added logger debug + transaction filter
  useEffect(() => {
    logger.info("FILTER DATA:", filterData);
    if (filterData?.transactionId) {
      setSearchFilters((prev) => ({
        ...prev,
        globalSearch: "",
        donorId: "",
        bookNo: "",
        remarks: "",
        receiptNo: "",
        transactionId: filterData.transactionId,
      }));
    }
  }, [filterData]);

  // Fetch PayPurpose only if store is empty
  useEffect(() => {
    if (!payPurposes || payPurposes.length === 0) {
      dispatch(fetchPayPurpose());
    }
  }, [dispatch, payPurposes]);

  const handleDeleteDonation = (donation) => {
    const parentReceipt = consolidatedDonations.find(
      (c) => c.parentDetails?._id === donation._id
    );

    if (
      parentReceipt &&
      parentReceipt.childReceipts &&
      parentReceipt.childReceipts.length > 0
    ) {
      setAlertMessage(
        "This parent receipt cannot be deleted because it has child receipts. Please delete the child receipts first."
      );
      setAlertOpen(true);
      return;
    }

    const hasPayPurpose = payPurposes.some(
      (p) =>
        p.donorId === donation.donorId &&
        p.transactionId === donation.transactionId
    );

    if (hasPayPurpose) {
      setAlertMessage(
        "This donation cannot be deleted because it has associated PayPurpose details."
      );
      setAlertOpen(true);
      return;
    }

    setSelectedDonation(donation);
    setOpenConfirm(true);
  };

  // ✅ phase3: consolidateDataHandler handles filter + grouping + count
  const {
    filteredConsolidatedDonations,
    groupedByDonor,
    totalIndividualDonations,
  } = useMemo(() => {
    return consolidateDataHandler(consolidatedDonations, searchFilters);
  }, [consolidatedDonations, searchFilters]);

  const paginatedDonors = useMemo(() => {
    const start = (page - 1) * donorsPerPage;
    return groupedByDonor.slice(start, start + donorsPerPage);
  }, [groupedByDonor, page]);

  const handleFilterChange = (filters) => {
    setSearchFilters(filters);
    setPage(1);
    logger.info("Donation table search applied", {
      filtersApplied: filters,
      username: user?.username,
      role: user?.role,
    });
  };

  // ✅ fixes branch: clear transaction filter chip handler
  const handleClearTransactionFilter = () => {
    setSearchFilters((prev) => ({ ...prev, transactionId: "" }));
    setPage(1);
  };

  const handleAddDonation = (data) => {
    const donorDetails = {
      donorId: data.donorId,
      firstName: data.firstName,
      lastName: data.lastName,
      mobile1: data.mobile1,
      city: data.city,
    };
    logger.info("Add donation clicked", {
      donorId: data.donorId,
      username: user?.username,
      role: user?.role,
    });
    onAppend(donorDetails);
  };

  const handleEdit = (data) => {
    logger.info("Edit donation clicked", {
      donorId: data.donorId,
      transactionId: data.transactionId,
      username: user?.username,
      role: user?.role,
    });
    onEdit(data);
  };

  const handleDeleteConfirm = () => {
    if (selectedDonation) {
      dispatch(deleteDonation(selectedDonation._id))
        .unwrap()
        .then(() => {
          setFeedback({
            open: true,
            message: "Donation deleted successfully",
            severity: "success",
          });
          logger.info("Donation deleted", {
            donorId: selectedDonation.donorId,
            transactionId: selectedDonation.transactionId,
            username: user?.username,
            role: user?.role,
          });
        })
        .catch((err) => {
          setFeedback({
            open: true,
            message: "Error deleting donation",
            severity: "error",
          });
          logger.error("Error deleting donation", {
            error: err,
            donorId: selectedDonation.donorId,
            transactionId: selectedDonation.transactionId,
            username: user?.username,
            role: user?.role,
          });
        });
    }
    setOpenConfirm(false);
    setSelectedDonation(null);
  };

  const handleViewHistory = (donation) => {
    if (donation.updateHistory && donation.updateHistory.length > 0) {
      setSelectedHistory(donation.updateHistory);
      setHistoryOpen(true);
      logger.info("View updated donation history modal open", {
        donorId: donation.donorId,
        transactionId: donation.transactionId,
        username: user?.username,
        role: user?.role,
      });
    } else {
      setFeedback({
        open: true,
        message: "No history available for this donation",
        severity: "info",
      });
      logger.info("No donation history available", {
        donorId: donation.donorId,
        transactionId: donation.transactionId,
        username: user?.username,
        role: user?.role,
      });
    }
  };

  const handleCloseHistory = () => {
    setHistoryOpen(false);
    setSelectedHistory([]);
    logger.info("View updated donation history modal close", {
      username: user?.username,
      role: user?.role,
    });
  };

  const handleCloseFeedback = () => {
    setFeedback({ ...feedback, open: false });
  };

  return (
    <>
      <Filter
        onFilterChange={handleFilterChange}
        values={searchFilters}
        fields={["donorId", "bookNo", "remarks", "receiptNo"]}
      />

      {/* ✅ fixes branch: transaction filter chip with clear button */}
      {searchFilters.transactionId && (
        <Box sx={{ mb: 1, mt: 0.5 }}>
          <Chip
            label={`Transaction ID: ${searchFilters.transactionId}`}
            onDelete={handleClearTransactionFilter}
            size="small"
            sx={{
              borderRadius: "16px",
              border: "1px solid #000",
              backgroundColor: "#fff",
              color: "#000",
              fontWeight: 500,
              "& .MuiChip-deleteIcon": {
                color: "red",
                "&:hover": { color: "#ff0000" },
              },
            }}
          />
        </Box>
      )}

      <Box display="flex" justifyContent="end">
        {role === "superadmin" || role === "admin1" || role === "admin2" ? (
          <Button
            onClick={() => {
              const allDonations = [];
              if (Array.isArray(consolidatedDonations)) {
                consolidatedDonations.forEach((consolidated) => {
                  if (consolidated?.parentDetails) {
                    allDonations.push(consolidated.parentDetails);
                  }
                });
              }
              exportDonationsToExcel(allDonations, user);
            }}
            variant="contained"
            color="primary"
          >
            <DriveFileMoveIcon /> Export
          </Button>
        ) : null}
      </Box>

      <TableContainer
        component={Paper}
        sx={{
          maxHeight: 782,
          overflowY: "auto",
          overflowX: "hidden",
          width: "100%",
        }}
      >
        <Table stickyHeader sx={{ width: "100%", tableLayout: "fixed" }}>
          <TableHead>
            {/* ✅ phase3: DnD sortable parent column headers */}
            <DndContext
              sensors={sensors}
              onDragEnd={(event) => {
                const { active, over } = event;
                if (!over || active.id === over.id) return;
                const oldIndex = parentColumns.findIndex(
                  (c) => c.id === active.id
                );
                const newIndex = parentColumns.findIndex(
                  (c) => c.id === over.id
                );
                reorderParentColumns(oldIndex, newIndex);
              }}
            >
              <SortableContext
                items={parentColumns
                  .filter((c) => c.visible !== false)
                  .map((c) => c.id)}
                strategy={horizontalListSortingStrategy}
              >
                <TableRow>
                  {parentColumns
                    .filter((c) => c.visible !== false)
                    .map((col) => (
                      <SortableColumnHeader key={col.id} column={col}>
                        <TableCell sx={{ width: col.width }}>
                          {col.label}
                        </TableCell>
                      </SortableColumnHeader>
                    ))}
                </TableRow>
              </SortableContext>
            </DndContext>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell
                  colSpan={
                    parentColumns.filter((c) => c.visible !== false).length
                  }
                >
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="100%"
                  >
                    <AgGridLoader loadingMessage="Fetching Donations, please wait..." />
                  </Box>
                </TableCell>
              </TableRow>
            ) : paginatedDonors.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={
                    parentColumns.filter((c) => c.visible !== false).length
                  }
                >
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="100%"
                  >
                    <Typography variant="h6">No Donations Found</Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              paginatedDonors.map((donor) => {
                // Safety check
                if (!donor || !donor.donorDetails) return null;

                const base = donor.receiptNo
                  ? donor.receiptNo.split("-")[0]
                  : "";
                const cons = consolidatedDonations.find(
                  (c) => c._id === base
                );

                const allDonations = [];
                donor.receipts.forEach((receipt) => {
                  if (receipt.parentDetails) {
                    allDonations.push({
                      ...receipt.parentDetails,
                      totalAmount:
                        receipt.totalAmount || receipt.parentDetails.amount,
                    });
                  }
                  if (
                    receipt.childReceipts &&
                    Array.isArray(receipt.childReceipts)
                  ) {
                    allDonations.push(...receipt.childReceipts);
                  }
                });

                const totalAmount = donor.receipts.reduce(
                  (sum, r) => sum + (r.totalAmount || 0),
                  0
                );

                const visibleParentColumns = parentColumns.filter(
                  (c) => c.visible !== false
                );

                return (
                  <RowWithPreferences
                    key={donor.donorId}
                    donor={donor.donorDetails}
                    allDonations={allDonations}
                    payPurposes={payPurposes}
                    donationCount={allDonations.length}
                    totalAmount={totalAmount}
                    onEdit={handleEdit}
                    onDelete={handleDeleteDonation}
                    onView={handleViewHistory}
                    onAppend={handleAddDonation}
                    role={role}
                    amount={cons ? cons.totalAmount : donor.amount}
                    columnPreferences={columns}
                    parentColumnPreferences={visibleParentColumns}
                    reorderColumns={reorderColumns}
                    reorderParentColumns={reorderParentColumns}
                    toggleColumnVisibility={toggleColumnVisibility}
                    toggleParentColumnVisibility={toggleParentColumnVisibility}
                    resetToDefault={resetToDefault}
                    resetParentToDefault={resetParentToDefault}
                  />
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mt={2}
      >
        <Typography variant="body2" color="textSecondary">
          {`${(page - 1) * donorsPerPage + 1} to ${Math.min(
            page * donorsPerPage,
            groupedByDonor.length
          )} of ${groupedByDonor.length} | Page ${page} of ${Math.ceil(
            groupedByDonor.length / donorsPerPage
          )}`}
        </Typography>

        <Pagination
          count={Math.ceil(groupedByDonor.length / donorsPerPage)}
          page={page}
          onChange={(e, value) => setPage(value)}
          color="primary"
          shape="rounded"
        />

        <Typography variant="body2" color="textSecondary">
          Total Donations: {totalIndividualDonations}
        </Typography>
      </Box>

      <HistoryModal
        title="Donation Updated History"
        open={historyOpen}
        onClose={handleCloseHistory}
        history={selectedHistory}
      />
      <ConfirmationDialog
        open={openConfirm}
        title="Confirm Deletion"
        message="Are you sure you want to delete this donation?"
        onConfirm={handleDeleteConfirm}
        onCancel={() => setOpenConfirm(false)}
      />
      <AlertMessage
        title="Donation Delete Alert"
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
      />
      <SnackbarAlert feedback={feedback} onClose={handleCloseFeedback} />
    </>
  );
};

export default DonationList;